import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { BridgeMark } from "../components/BridgeMotif";
import { Button } from "../components/ui/button";

export default function NotFound() {
  const { t } = useLang();
  return (
    <div className="mx-auto flex max-w-lg flex-col items-center px-4 py-28 text-center">
      <BridgeMark size={72} />
      <h1 className="mt-8 font-display text-3xl font-bold tracking-tight text-slateink">{t("notfound.title")}</h1>
      <p className="mt-3 text-muted-foreground">{t("notfound.desc")}</p>
      <Button asChild className="mt-8 rounded-full bg-terracotta hover:bg-terracotta-hover" data-testid="notfound-home-btn">
        <Link to="/">{t("notfound.home")}</Link>
      </Button>
    </div>
  );
}
